import React from "react";
import { withRouter } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import cx from "classnames";

import "../assets/styles/crew-assignment-status.css";
import { dashboardActions } from "_actions";
import { dashboardService } from "../_services";
import { getEmployeesBirthdays, isEmployeeBirthdayLoading } from "_helpers/reduxSelector";
import styles from "./birthdayWidget.module.css";
import { redirectToPdf } from "_helpers/redirectToPdf";
import { formatDate } from "_helpers/helpers";

const dateFormat = "MM/DD/YY";

const BirthdayWidget = ({ toggle, widgetid, visibility, history, isReportMenu }) => {
  const dispatch = useDispatch();

  const [date, setDate] = React.useState(moment().format(dateFormat));
  const [isToday, setIsToday] = React.useState(false);

  const response = useSelector((state) => getEmployeesBirthdays(state));

  const isLoading = useSelector((state) => isEmployeeBirthdayLoading(state));

  React.useEffect(() => {
    getBirthdays();
  }, [date, isToday]);

  const getBirthdays = () => {
    let payload = new FormData();
    payload.append("date", date);
    payload.append("today", isToday ? 1 : 0);
    dispatch(dashboardActions.getEmployeesBirthday(payload));
  };

  const onExportClick = () => {
    let data = new FormData();
    data.append("date", date);
    data.append("today", isToday ? 1 : 0);
    data.append(" report_type","csv")
    dashboardService?.generateBdayReport(data);
  };

  const onPrintClick = () => {
    let data = new FormData();
    data.append("date", date);
    data.append("today", isToday ? 1 : 0);
    data.append(" report_type","pdf")
    dashboardService.printEmployeeBirthdaysReportPdf(data).then(res=>redirectToPdf(res))
  }

  const handleOnMonthChange = (type) => {
    setIsToday(false);
    if (type === "NEXT") {
      setDate(moment(date).add(1, "months").format(dateFormat));
    } else {
      setDate(moment(date).subtract(1, "months").format(dateFormat));
    }
  };

  const handleOnTodayClick = () => {
    setIsToday(!isToday);
    setDate(moment().format(dateFormat));
  };

  const data = React.useMemo(() => {
    let mappedData = {};
    const currentMonth = Object.keys(response ?? {})?.[0];

    const dates = Object.keys(response?.[currentMonth] ?? {})?.sort((a, b) => a - b);

    dates?.forEach(
      (_date) => (mappedData[`${currentMonth}/${_date}/${moment(date).year()}`] = response?.[currentMonth]?.[_date])
    );
    return { keys: Object.keys(mappedData ?? {}), values: mappedData };
  }, [response]);

  const noDataAvailable = !isLoading && !data?.keys?.length;

  return (
    <div className="dashboard_expiration_date_outer">
      {!isReportMenu && (
        <div className="dashboard_expiration_date inner_head">
          <div className={styles?.widget_header}>
            <h2>
              Birthdays<span className="drag-icon-controller"></span>
            </h2>
            {isLoading && (
              <img
                alt="loader"
                className="login_loader"
                src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
              />
            )}
          </div>

          <span
            className="toggle-controller"
            aria-owns="birthday-widget"
            onClick={(event) => {
              toggle(event, widgetid);
            }}
          ></span>
        </div>
      )}

      <div
        className="employee_stats_details assignment_stats-details"
        aria-expanded={visibility == 1 ? "true" : "false"}
        id="birthday-widget"
        style={{ boxShadow: isReportMenu ? "unset" : "inherit" }}
      >
        <div className={styles?.header}>
          <div className={styles?.header_first}>
            <div className={styles?.header_action}>
              <button
                disabled={isLoading}
                onClick={() => handleOnMonthChange("PREV")}
              >
                <i class="fas fa-chevron-left"></i>
              </button>
              <button
                disabled={isLoading}
                onClick={() => handleOnMonthChange("NEXT")}
                className={styles?.header_action_margin}
              >
                <i class="fas fa-chevron-right"></i>
              </button>
              <button
                onClick={() => handleOnTodayClick()}
                disabled={isLoading}
                className={
                  isToday
                    ? styles?.header_action_today_active
                    : styles?.header_action_today
                }
              >
                Today
              </button>
            </div>
            <div className={styles?.header_title}>
              <h5>{moment(date).format("MMMM YYYY")}</h5>
            </div>
          </div>
          {!noDataAvailable && (
              <div className={styles.print_btn_container}>
                <button
                  href=""
                  className={cx(styles?.print_btn, "print_button")}
                  onClick={(event) => {
                    onExportClick();
                  }}
                >
                  {/* <img alt="" src={require("../assets/images/print.svg").default} /> Print */}
                  Export
                </button>
                <button
                  href=""
                  className={cx(styles?.print_btn, "print_button")}
                  style={{marginLeft:"10px"}}
                  onClick={(event) => {
                    onPrintClick();
                  }}
                >
                  {/* <img alt="" src={require("../assets/images/print.svg").default} /> Print */}
                  Print
                </button>
              </div>
          )}
        </div>
        <div className={styles?.content}>
          {noDataAvailable ? (
            <div className={styles?.no_records}>
              <p>No birthdays this month.</p>
            </div>
          ) : (
            data?.keys?.map((item, index) => (
              <>
                <div key={index} className={styles?.item_head}>
                  <div>
                       <h5>{formatDate(date)}</h5>
                  </div>


                  <div>
                    <h5>{`${moment(
                      `${moment(item).format("MM/DD")}/${moment(date).format(
                        "YY"
                      )}`
                    ).format("dddd")}`}</h5>
                  </div>
                </div>
                {data?.values?.[item]?.map((child, childIndex) => (
                  <div key={childIndex} className={styles?.item_child}>
                    <div>
                      <h6>{`${child?.last_name} ${child?.first_name}`}</h6>
                    </div>
                    {/* <div>
                      <h6>{child.is_locked === 1?"Locked":"Available"}</h6>
                    </div> */}
                  </div>
                ))}
              </>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(BirthdayWidget);
